
<nav class="navigation">
    @defer (on viewport ) {
        <ol itemscope itemtype="https://schema.org/BreadcrumbList">
            <li
                *ngFor="
                    let item of (breadcrumbService.breadcrumb$ | async) | slice: sliceStart:sliceEnd;
                    let i = index;
                    let isFirst = first;
                    let isLast = last
                "
                itemprop="itemListElement"
                itemscope
                itemtype="https://schema.org/ListItem"
            >
                <a
                    class="item"
                    [ngClass]="{ 'last-item': isLast && !isMobile }"
                    itemprop="item"
                    itemtype="http://schema.org/Thing"
                    [routerLink]="[item.url]"
                >
                    <app-svg-icon class="home-icon" *ngIf="isFirst && !isMobile" iconName="store"></app-svg-icon>
                    <app-svg-icon class="arrow-icon" *ngIf="isMobile" iconName="chevron_left"></app-svg-icon>
                    <span class="item-text kk-hover-underline" itemprop="name">{{ item.name }}</span>
                    <app-svg-icon class="arrow-icon" *ngIf="!isLast && !isMobile" iconName="chevron_right"></app-svg-icon>
                </a>
                <meta itemprop="position" content="{{ i + 1 }}" />
            </li>
        </ol>
    } @placeholder {
        <div class="item placeholder">
            <app-loading-dots></app-loading-dots>
        </div>
    }
</nav>
